module.exports = __webpack_public_path__ + "img/p40.6d0946c2.svg";